<template>
  <div
    class="blockquote section"
    :style="sectionStyle"
  >
    <div
      v-if="description"
      :style="[descriptionStyle, blockquoteStyle]"
      class="description container flex justify-center"
    >
      <div :class="{ 'q-mb-lg': showAuthor && fullName }">
        {{ description }}
      </div>
      <div
        v-if="showAuthor && fullName"
        class="flex"
      >
        <img
          v-if="photoUrl"
          :src="photoUrl"
          alt="avatar"
          class="avatar q-mr-md"
          width="50"
          height="50"
        >
        <div class="text-16-400 column justify-center items-start">
          <div>
            {{ fullName }}
          </div>
          <div
            v-if="authorPosition"
            style="opacity: 0.5"
          >
            {{ authorPosition }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import backgroundMixin from './mixins/backgroundMixin';
import descriptionMixin from './mixins/descriptionMixin';

export default {
  name: 'BlockquoteSection',
  mixins: [backgroundMixin, descriptionMixin],
  props: {
    blockquoteBackgroundColor: {
      type: String,
      default: undefined,
    },
    showAuthor: {
      type: Boolean,
      default: false,
    },
    fullName: {
      type: String,
      default: undefined,
    },
    authorPosition: {
      type: String,
      default: undefined,
    },
    photoUrl: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    blockquoteStyle() {
      return {
        backgroundColor: this.blockquoteBackgroundColor,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.blockquote {
  .description {
    padding: 20px;
    text-align: center;
    border-radius: 20px;

    .avatar {
      border-radius: 50px;
      object-fit: cover;
    }
  }
}
</style>
